var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"className":"outer-circle","cx":"89","cy":"89","r":"89","fill":"#000","fillOpacity":".2","key":0}),React.createElement("circle",{"className":"inner-circle","cx":"89","cy":"89","r":"71","fill":"#009FAF","fillOpacity":".3","key":1}),React.createElement("path",{"className":"right-triangle","fill":"#FFF","d":"M70.57 53.537l51.837 31.066a5 5 0 0 1 .012 8.57L70.582 124.43A5 5 0 0 1 63 120.147V57.826a5 5 0 0 1 7.57-4.29z","key":2})]));
}

PlayButton.defaultProps = {"width":"178","height":"178","viewBox":"0 0 178 178"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
